import {Form, formsStore} from '../../../../stores/Form';
import {priority} from '@priority-software/priority-proto-api/lib';

type Props = {
    formName: string;
    startSubFormRes: priority.netitems.form.IStartRs;
    columnsRs: priority.netitems.form.IColumnsRs;
    subFormLevel: number;
    formCustomData: {[key: string]: any};
};

export const createSubFormInstance = (session: string, payload: Props) => {
    const {formName, startSubFormRes, columnsRs, subFormLevel, formCustomData} = payload;
    const screen = formsStore.getScreenBySession(session);
    const form = screen?.form;
    const activeSubForm = form?.activeSubForm;

    if (
        activeSubForm &&
        activeSubForm.ename === formName &&
        activeSubForm.level === payload.subFormLevel
    ) {
        return activeSubForm;
    }

    return new Form(formName, startSubFormRes, columnsRs, subFormLevel, formCustomData);
};
